import { Component, Input, OnInit } from '@angular/core';
import { OptInModalInfo } from "../../../message-models/optin-modal-info.class";
import { IOptInModalInfo } from "../../../message-models/optin-modal-info.interface";
import { AuthorizeService } from "../../../../api-authorization/authorize.service";
import { Router } from "@angular/router";
import { CompanyOptInService } from "../../services/company-opt-in.service";
//import { IEcaDialogRef } from '../../../shared/models/eca-dialog-ref.interface';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CompanyInfo } from "../../../domain-model/company-info.class";

@Component({
  selector: 'app-agree-contract-modal',
  templateUrl: './agree-contract-modal.component.html',
  styleUrls: ['./agree-contract-modal.component.scss']
})
export class AgreeContractModalComponent implements OnInit {
  @Input() modalDetails: OptInModalInfo = new OptInModalInfo({} as IOptInModalInfo);
  @Input() company: CompanyInfo;

  constructor(public modalRef: DynamicDialogRef, private companyOptInService: CompanyOptInService, private authorizeService: AuthorizeService, private router: Router) { }

  ngOnInit(): void {
  }

  signOut() {
    this.authorizeService.signOut('App').then(result =>
      this.router.navigate(['/'])
    );
  }

  agreeContract() {
    this.companyOptInService.recordContractAgreed(this.company?.id).subscribe(result => {
      if (result && result.contractAgreed) {
        this.modalRef.close();
      }
    })
  }
}
